export default __webpack_public_path__ + "static/media/ff894076e626acde1137673c9670a1c1.svg";